// @flow

import updateValuationItemPercentage from '../../../Services/updateValuationItemPercentage';
import type { UpdateValuationItemPercentageParams } from '../../../types';

export default (params: UpdateValuationItemPercentageParams) => async (dispatch: Function) => dispatch(updateValuationItemPercentage(params));